window.arrow_key = function(){
    var keyque = 1;
    var keyque_old;
    var ttaken_old = "00";
    var $keyarr = jQuery.noConflict();

    if (navigator.userAgent.match(/Mobi/)) {
        var windowWidth = 100;
    }
    else
    {
        var windowWidth = 1359;
    }
     $keyarr(".blank-answered").attr('data-time', "00");
       var total = parseInt($keyarr("body").attr('total-pas-que'));

    function keycount(key_div_id)
    {
        keyque = parseInt(key_div_id);
    }

    function captureTime()
            {
            /**** Calculation time start here ***********/
            var ttaken = $keyarr("#stopwatch").html();  /***** getting time form stop watch *******/
                    var ttaken_s1 = ttaken.substr(0, 2);    /***** getting mins from time *******/
                            ttaken_s1 = ttaken_s1 * 60;     /******* converting mins to seconds *******/
                    var ttaken_s2 = ttaken.substr(3, 2);    /***** getting secs from time *******/
                    var ttaken_n =  ttaken_s1 + parseInt(ttaken_s2);    /******getting total secs *****/
                    var ttaken_new = ttaken_n - ttaken_old;     /**** getting total time taken ******/

                    var exist_value = $keyarr(".lsat-question-selected").attr('data-time');  /****** getting previous time taken by user for that same question *****/
                    var exist_value_new = exist_value;

                    var ttaken_total = parseInt(ttaken_new) + parseInt(exist_value_new);
                    var datatbid = $keyarr(".lsat-question-selected").attr("question-sequence");
                    var data_time_attr = $keyarr(".lsat-question-selected").attr("data-time");
                    $keyarr("#t"+datatbid).html(ttaken_total);
                    $keyarr(".lsat-question-selected").attr('data-time', ttaken_total);
                    ttaken_old = ttaken_n;
                    $keyarr("#time-spent-"+datatbid).val(ttaken_total);
                    /******** calculation time end here *********/
            }

    /*************code for keyboard event starts here ************/
    $keyarr(document).keydown(function(e){
        if($keyarr( "#open-block1" ).hasClass( "fade-block" ))
        {
            return false;
        }
        else
        {
            //do nothing
        }
        /***********for key up *************/
        if (e.keyCode == 38) {
           keyque_old =  keyque;  
           keyque =  keyque - 1;
           if(keyque < 1)
           {
               keyque = 1;
           }

           $keyarr( "#que"+keyque ).addClass( "lsat-question-selected" );
           if( keyque_old != 1)
            {
                $keyarr( "#que"+keyque_old ).removeClass( "lsat-question-selected" );
            }

           return false;
        }
        /***********for key down *************/
        if (e.keyCode == 40) { 
           keyque_old =  keyque; 
           keyque =  (keyque + 1);
           if(keyque > total)
           {
               keyque = total;
           }

           $keyarr( "#que"+keyque ).addClass( "lsat-question-selected" );
            if( keyque_old != total)
            {
                $keyarr( "#que"+keyque_old ).removeClass( "lsat-question-selected" );
            }

           return false;
        }

        /**************** code for alhapbets key ***************/
        if (( e.keyCode >= 65 ) && ( e.keyCode <= 69 )) {
            if(e.keyCode == 65)
            {

                $keyarr( ".lsat-question-selected .opt-a.answer-radio-button" ).toggleClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-b.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-c.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-d.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-e.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                if($keyarr( ".lsat-question-selected .opt-a.answer-radio-button" ).attr("class") == "opt-a answer-radio-button lsat-selected-answer-active")
                {
                    $keyarr(".lsat-question-selected input").val("A");
                    captureTime();
                }
                else
                {
                    $keyarr(".lsat-question-selected input").val("");
                    captureTime();
                }
                keyque_old =  keyque; 
                keyque =  keyque + 1;
                if(keyque > total)
                {
                    keyque = total;
                }


                $keyarr( "#que"+keyque ).addClass( "lsat-question-selected" );
                 if( keyque_old != total)
                 {
                     $keyarr( "#que"+keyque_old ).removeClass( "lsat-question-selected" );
                 }


                return false;
            }
            if(e.keyCode == 66)
            {
                $keyarr( ".lsat-question-selected .opt-a.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-b.answer-radio-button" ).toggleClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-c.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-d.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-e.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                if($keyarr( ".lsat-question-selected .opt-b.answer-radio-button" ).attr("class") == "opt-b answer-radio-button lsat-selected-answer-active")
                {
                    $keyarr(".lsat-question-selected input").val("B");
                    captureTime(); 
                }
                else
                {
                    $keyarr(".lsat-question-selected input").val("");
                    captureTime();
                }
                keyque_old =  keyque; 
                keyque =  keyque + 1;
                if(keyque > total)
                {
                    keyque = total;
                }

                $keyarr( "#que"+keyque ).addClass( "lsat-question-selected" );
                 if( keyque_old != total)
                 {
                     $keyarr( "#que"+keyque_old ).removeClass( "lsat-question-selected" );
                 }

                return false;
            }
            if(e.keyCode == 67)
            {
                $keyarr( ".lsat-question-selected .opt-a.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-b.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-c.answer-radio-button" ).toggleClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-d.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-e.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                if($keyarr( ".lsat-question-selected .opt-c.answer-radio-button" ).attr("class") == "opt-c answer-radio-button lsat-selected-answer-active")
                {
                    $keyarr(".lsat-question-selected input").val("C");
                     captureTime(); 
                }
                else
                {
                    $keyarr(".lsat-question-selected input").val("");
                    captureTime();
                }
                keyque_old =  keyque; 
                keyque =  keyque + 1;
                if(keyque > total)
                {
                    keyque = total;
                }

                $keyarr( "#que"+keyque ).addClass( "lsat-question-selected" );
                 if( keyque_old != total)
                 {
                     $keyarr( "#que"+keyque_old ).removeClass( "lsat-question-selected" );
                 }

                return false;
            }
            if(e.keyCode == 68)
            {
                $keyarr( ".lsat-question-selected .opt-a.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-b.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-c.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-d.answer-radio-button" ).toggleClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-e.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                if($keyarr( ".lsat-question-selected .opt-d.answer-radio-button" ).attr("class") == "opt-d answer-radio-button lsat-selected-answer-active")
                {
                    $keyarr(".lsat-question-selected input").val("D");
                    captureTime(); 
                }
                else
                {
                    $keyarr(".lsat-question-selected input").val("");
                    captureTime();
                }
                keyque_old =  keyque; 
                keyque =  keyque + 1;
                if(keyque > total)
                {
                    keyque = total;
                }

                $keyarr( "#que"+keyque ).addClass( "lsat-question-selected" );
                 if( keyque_old != total)
                 {
                     $keyarr( "#que"+keyque_old ).removeClass( "lsat-question-selected" );
                 }

                return false;
            }
            if(e.keyCode == 69)
            {
                $keyarr( ".lsat-question-selected .opt-a.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-b.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-c.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-d.answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                $keyarr( ".lsat-question-selected .opt-e.answer-radio-button" ).toggleClass( "lsat-selected-answer-active" );
                if($keyarr( ".lsat-question-selected .opt-e.answer-radio-button" ).attr("class") == "opt-e answer-radio-button lsat-selected-answer-active")
                {
                    $keyarr(".lsat-question-selected input").val("E");
                     captureTime(); 
                }
                else
                {
                    $keyarr(".lsat-question-selected input").val("");
                    captureTime();
                }
                keyque_old =  keyque; 
                keyque =  keyque + 1;
                if(keyque > total)
                {
                    keyque = total;
                }

                $keyarr( "#que"+keyque ).addClass( "lsat-question-selected" );
                 if( keyque_old != total)
                 {
                     $keyarr( "#que"+keyque_old ).removeClass( "lsat-question-selected" );
                 }

                return false;
            }
        }
    });
    /*************code for keyboard event ends here ************/


    /*************code for mouse event starts here ************/
    var qid;
    var queid;
    for(qid = 1; qid <= total; qid++)
    {
        if( windowWidth > 1024 ){

            $keyarr("#que"+qid).click(function(){

                for(var queid = 1; queid <= total; queid++)
                {

                    $keyarr( "#que"+queid ).removeClass( "lsat-question-selected" );
                }
                var qidd = qid + 1;
                $keyarr( this ).addClass( "lsat-question-selected" );

                var x = $keyarr(".lsat-question-selected").attr('question-sequence');
                var y = parseInt(x) + parseInt(1);
                if(x != total)
                {
                    $keyarr( ".lsat-question-selected" ).removeClass( "lsat-question-selected" );
                }
                $keyarr( "#que"+y ).addClass( "lsat-question-selected" );
                var keyque = $keyarr( ".lsat-question-selected" ).attr( "question-sequence" );
                keycount(keyque);

            });

            $keyarr("#que"+qid+" .answer-radio-button").click(function(){

                var data = $keyarr(this).attr("data-option");
                var quest_id = $keyarr(this).closest('div').attr('id');
                if($keyarr( this ).hasClass( "lsat-selected-answer-active" ))
                {
                    //do nothing
                }
                else
                {
                    $keyarr( "#"+quest_id+" .answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                }
                $keyarr( this ).toggleClass( "lsat-selected-answer-active" );
                if($keyarr( this ).attr("class") == "opt-a answer-radio-button lsat-selected-answer-active" || $keyarr( this ).attr("class") == "opt-b answer-radio-button lsat-selected-answer-active" || $keyarr( this ).attr("class") == "opt-c answer-radio-button lsat-selected-answer-active" || $keyarr( this ).attr("class") == "opt-d answer-radio-button lsat-selected-answer-active" || $keyarr( this ).attr("class") == "opt-e answer-radio-button lsat-selected-answer-active")
                {
                    $keyarr(this).siblings('input').val(data);
                }
                else
                {
                    $keyarr(this).siblings('input').val("");
                }


                        /**** Calculation time start here ***********/
                        var ttaken = $keyarr("#stopwatch").html();

                        var ttaken_s1 = ttaken.substr(0, 2);
                                ttaken_s1 = ttaken_s1 * 60;
                        var ttaken_s2 = ttaken.substr(3, 2);
                        var ttaken_n =  ttaken_s1 + parseInt(ttaken_s2);
                        var ttaken_new = ttaken_n - ttaken_old;

                        var exist_value = $keyarr(this).parents(".blank-answered").attr('data-time');
                        var exist_value_new = exist_value;

                        var ttaken_total = parseInt(ttaken_new) + parseInt(exist_value_new);
                        var datatbid = $keyarr(this).parents(".blank-answered").attr("question-sequence");
                        var data_time_attr = $keyarr(".lsat-question-selected").attr("data-time");
                        $keyarr("#t"+datatbid).html(ttaken_total);
                        $keyarr(this).parents(".blank-answered").attr('data-time', ttaken_total);
                        ttaken_old = ttaken_n;
                        $keyarr("#time-spent-"+datatbid).val(ttaken_total);

                        /******** calculation time end here *********/
            });
        }
        else{

            /********* touch effect starts here ********/

            $keyarr("#que"+qid).on("touchstart.tap",function(e){

                for(var queid = 1; queid <= total; queid++)
                {

                    $keyarr( "#que"+queid ).removeClass( "lsat-question-selected" );
                }
                var qidd = qid + 1;
                $keyarr( this ).addClass( "lsat-question-selected" );

                var x = $keyarr(".lsat-question-selected").attr('question-sequence');
                var y = parseInt(x) + parseInt(1);
                if(x != total)
                {
                    $keyarr( ".lsat-question-selected" ).removeClass( "lsat-question-selected" );
                }
                $keyarr( "#que"+y ).addClass( "lsat-question-selected" );
                var keyque = $keyarr( ".lsat-question-selected" ).attr( "question-sequence" );
                keycount(keyque);

            });

            $keyarr("#que"+qid+" .answer-radio-button").on("touchstart.tap",function(e){
               var data = $keyarr(this).attr("data-option");
                var quest_id = $keyarr(this).closest('div').attr('id');
                if($keyarr( this ).hasClass( "lsat-selected-answer-active" ))
                {
                    //do nothing
                }
                else
                {
                    $keyarr( "#"+quest_id+" .answer-radio-button" ).removeClass( "lsat-selected-answer-active" );
                }
                $keyarr( this ).toggleClass( "lsat-selected-answer-active" );
                if($keyarr( this ).attr("class") == "opt-a answer-radio-button lsat-selected-answer-active" || $keyarr( this ).attr("class") == "opt-b answer-radio-button lsat-selected-answer-active" || $keyarr( this ).attr("class") == "opt-c answer-radio-button lsat-selected-answer-active" || $keyarr( this ).attr("class") == "opt-d answer-radio-button lsat-selected-answer-active" || $keyarr( this ).attr("class") == "opt-e answer-radio-button lsat-selected-answer-active")
                {
                    $keyarr(this).siblings('input').val(data);
                }
                else
                {
                    $keyarr(this).siblings('input').val("");
                }


                        /**** Calculation time start here ***********/
                        var ttaken = $keyarr("#stopwatch").html();

                        var ttaken_s1 = ttaken.substr(0, 2);
                                ttaken_s1 = ttaken_s1 * 60;
                        var ttaken_s2 = ttaken.substr(3, 2);
                        var ttaken_n =  ttaken_s1 + parseInt(ttaken_s2);
                        var ttaken_new = ttaken_n - ttaken_old;

                        var exist_value = $keyarr(this).parents(".blank-answered").attr('data-time');
                        var exist_value_new = exist_value;

                        var ttaken_total = parseInt(ttaken_new) + parseInt(exist_value_new);
                        var datatbid = $keyarr(this).parents(".blank-answered").attr("question-sequence");
                        var data_time_attr = $keyarr(".lsat-question-selected").attr("data-time");
                        $keyarr("#t"+datatbid).html(ttaken_total);
                        $keyarr(this).parents(".blank-answered").attr('data-time', ttaken_total);
                        ttaken_old = ttaken_n;
                        $keyarr("#time-spent-"+datatbid).val(ttaken_total);
;
                        /******** calculation time end here *********/
            });

            /********* touch effect ends here ********/
        }
    }
    /*************code for keyboard event ends here ************/
}
